import { API, axiosInstance } from "lib";

export const getMasterData = (data = {}) => {
  return axiosInstance
    .get(API.MASRER_DATA + `?` +`appVersion=${data?.appVersion}`)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
      throw err;
    });
};